/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Home from './Home';
import { homeFetch, needWindow } from '../../actions/home';
import { fetchHotWords } from '../../actions/search';
import { trackEventLog } from '../../core/utils'

async function action({ store }) {
  trackEventLog('/w/')
  await store.dispatch(needWindow())
  await store.dispatch(homeFetch())
  await store.dispatch(fetchHotWords(''))
  // if (!store.getState().home.fixedEntries.length) await store.dispatch(homeFetch());
  if (global && global.NProgress) {
    global.NProgress.done()
  }
  return {
    chunks: ['home'],
    title: '有道精品课',
    keywords: '有道精品课,网易有道,有道博闻,有道英语,有道领事,在线教育,在线课堂,围棋,象棋,国际象棋,名师,小学,初中,高中,兴趣,素养,英语,升学,大学,语文,数学,AI,考研,四六级,雅思,听说口语,小语种,专四专八,成人教育,职业考证',
    description: '有道精品课是网易旗下的知名教育培训品牌，覆盖小学、初中、高中、升学、兴趣素养、围棋、象棋、大学、兴趣技能、小语种、托福雅思、英语口语、考证考级、职业培训技能等全面课程。有道优秀的教师团队，为你量身定制学习方案，提高学习效率，改善薄弱方向，取得学业进步。',
    component: <Home />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/home/index.js